<template lang="html">
  <div class="cart-list flex flex-col gap-2">
    <CartItem
      v-for="pair in items"
      :key="`item.${pair.item.id}_${pair.index}`"
      :value="pair.item"
      :attributes-meta="attributesMeta"
      :selectable="props.selectable"
      :selected="props.selectable && isItemSelected(pair.item.id!, pair.index)"
      :show-notify="props.showNotify"
      :unit-price="props.lineUnitPrices?.get(pair.item.id!)"
      @remove="emit('remove', $event)"
      @update:selected="
        emit('update:selected', {
          id: pair.item.id!,
          index: pair.index,
          value: $event,
        })
      "
      @toggle-notify="emit('toggleNotify', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import type { CartProductListItemDto } from '@repo/api/web/models'

import CartItem from './CartItem.vue'

interface SelectedEntry {
  id: number
  index: number
}

const props = withDefaults(
  defineProps<{
    value?: CartProductListItemDto[]
    attributesMeta?: Record<string, object>
    selectable?: boolean
    selected?: SelectedEntry[]
    showNotify?: boolean
    lineUnitPrices?: Map<number, number>
  }>(),
  {
    value: () => [],
    selectable: false,
    selected: () => [],
    showNotify: false,
    lineUnitPrices: () => new Map(),
  },
)
const emit = defineEmits<{
  remove: [productId: number]
  'update:selected': [payload: SelectedEntry & { value: boolean }]
  toggleNotify: [productId: number]
}>()

const items = computed(() =>
  props.value.flatMap(item =>
    Array.from({ length: item.amount || 1 }, (_, index) => ({ item, index })),
  ),
)

function isItemSelected(id: number, index: number): boolean {
  return props.selected.some(
    selectedItem => selectedItem.id === id && selectedItem.index === index,
  )
}
</script>
